import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { EmailService } from "../../../services/email.service";

@Component({
  selector: "app-link-debtor-response-dialog",
  templateUrl: "./link-debtor-response-dialog.component.html",
  styleUrls: ["./link-debtor-response-dialog.component.scss"],
})
export class LinkDebtorResponseDialogComponent implements OnInit {
  operations = [];
  selectedIndexes = new Set<number>();
  contactIcons = { from: "loading", cc: "loading" };
  validContacts = false;
  targetReply;
  isFromFinsmart = false;
  contactsValidation: {
    validFrom: boolean;
    isFromFinsmart: boolean;
    hasAllValidatedContacts: boolean;
    foundedValidatedContacts: string[];
    hasUnValidatedContacts: boolean;
    unvalidatedContacts: string[];
  };
  hasAllValidatedContactsMessage = "";
  isEmailThreadFound = false;

  constructor(
    public dialogRef: MatDialogRef<LinkDebtorResponseDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private router: Router,
    private emailService: EmailService
  ) {}

  ngOnInit(): void {
    this.targetReply = this.data.email.replies.find(
      (re) => re.emailId === this.data.replyId
    );
    this.targetReply.cc = this.targetReply.cc
      ?.split(",")
      ?.map((email: string) => email.trim())
      .filter((email: string) => !email.includes("finsmart"))
      .join(", ");
    this.getOperations();
  }

  getOperations() {
    this.emailService
      .getOperationsToBeLinked(this.data.email.emailId, this.data.replyId)
      .subscribe((data) => {
        this.operations = data?.invoices;
        this.contactsValidation = data?.contactsValidation;
        this.isEmailThreadFound = true;
      });
  }

  toggleSelection(index: number) {
    if (this.selectedIndexes.has(index)) {
      this.selectedIndexes.delete(index);
    } else {
      this.selectedIndexes.add(index);
    }
  }

  goToDetail(index) {
    this.router.navigate([]).then((result) => {
      window.open("/invoices/" + this.operations[index]?._id, "_blank");
    });
  }

  validForm(): boolean {
    if (this.contactsValidation?.validFrom && this.selectedIndexes.size > 0) {
      return true;
    } else {
      return false;
    }
  }

  searchByDebtor(debtorId: string) {
    this.emailService
      .getOperationsByDebtor(debtorId, this.data.email.emailId, this.data.replyId)
      .subscribe((data) => {
        this.operations = data?.invoices;
        this.contactsValidation = data?.contactsValidation;
      });
  }

  submit() {
    const selectedOperations = Array.from(this.selectedIndexes).map(
      (index) => this.operations[index]
    );

    const operationsString = selectedOperations.map((op) => op._id).join(",");

    const payload = {
      emailId: this.data.email.emailId,
      emailReplyId: this.data.replyId,
      operationIds: operationsString,
      status: this.contactsValidation.isFromFinsmart ? "exception" : "approved",
      hasAllValidatedContacts: this.contactsValidation.hasAllValidatedContacts,
      foundedValidatedContacts:
        this.contactsValidation.foundedValidatedContacts?.join(", "),
    };
    this.dialogRef.close(payload);
  }

  close() {
    this.dialogRef.close();
  }

  arrayToString(arr) {
    return arr.join(", ");
  }

  getButtonLabel(): string {
    let label = "Vincular";
    if (this.contactsValidation?.isFromFinsmart) {
      label = "Vincular con excepción";
    }

    if (!this.contactsValidation?.hasAllValidatedContacts) {
      this.hasAllValidatedContactsMessage =
        "Al vincular, se pondrá en copia a los contactos validados que aún no hayan sido copiados.";
    }

    return label;
  }
}
